import { gql } from '@apollo/client'

export const MUTATION_SEND_ACTIVATION_LINK = gql`
  mutation mutationSendActivationLink($id: ID!) {
    sendActivationLink(employeeID: $id)
  }
`
